// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,400;0,500;0,600;0,700;1,300&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*{
    font-family: 'Poppins', sans-serif;
}
.footer {
  padding: 4rem 6rem;
  background: skyblue;
  color: #222;
}
.logo img{
  font-size: 2rem;
  /* background-color: #3b5998; */
  justify-content: start;
  
  align-items: center;
  border-radius: 6px;
}
.top {
  display: flex;
  align-items: center;
  text-align: start;
  justify-content: space-between;
  flex-wrap: wrap;
}
.top i {
  color: #222;
  font-size: 1.2rem;
  margin-left: 1rem;
}
.top i:hover {
  color: #222;
}

.bottom {
  padding-top: 2rem;
  text-align: start;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.bottom div {
  display: flex;
  flex-direction: column;
}
.bottom h4 {
  font-size: 1.3rem;
  padding: 1rem 0 0.8rem 0;
}
.bottom a {
  text-decoration: none;
  color: #222;
  padding-bottom: 0.4rem;
  font-size: 1.1rem;
}
.Policy a{
  color: #222;
  padding-bottom: 0.4rem;
  font-size: 1.1rem;
}
@media (max-width: 319px) {
  .fa-solid.fa-envelope p {
    display: none;
  }
}
@media screen and (max-width: 850px) {
  .footer {
    padding: 4rem 2rem;
  }
  .footer i {
    margin: 1rem 1rem 0 0;
  }

  .bottom div {
    width: 50%;
  }
}


`, "",{"version":3,"sources":["webpack://./src/footer1.css"],"names":[],"mappings":"AACA;IACI,kCAAkC;AACtC;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,eAAe;EACf,+BAA+B;EAC/B,sBAAsB;;EAEtB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,qBAAqB;EACvB;;EAEA;IACE,UAAU;EACZ;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,400;0,500;0,600;0,700;1,300&display=swap');\r\n*{\r\n    font-family: 'Poppins', sans-serif;\r\n}\r\n.footer {\r\n  padding: 4rem 6rem;\r\n  background: skyblue;\r\n  color: #222;\r\n}\r\n.logo img{\r\n  font-size: 2rem;\r\n  /* background-color: #3b5998; */\r\n  justify-content: start;\r\n  \r\n  align-items: center;\r\n  border-radius: 6px;\r\n}\r\n.top {\r\n  display: flex;\r\n  align-items: center;\r\n  text-align: start;\r\n  justify-content: space-between;\r\n  flex-wrap: wrap;\r\n}\r\n.top i {\r\n  color: #222;\r\n  font-size: 1.2rem;\r\n  margin-left: 1rem;\r\n}\r\n.top i:hover {\r\n  color: #222;\r\n}\r\n\r\n.bottom {\r\n  padding-top: 2rem;\r\n  text-align: start;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  flex-wrap: wrap;\r\n}\r\n.bottom div {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n.bottom h4 {\r\n  font-size: 1.3rem;\r\n  padding: 1rem 0 0.8rem 0;\r\n}\r\n.bottom a {\r\n  text-decoration: none;\r\n  color: #222;\r\n  padding-bottom: 0.4rem;\r\n  font-size: 1.1rem;\r\n}\r\n.Policy a{\r\n  color: #222;\r\n  padding-bottom: 0.4rem;\r\n  font-size: 1.1rem;\r\n}\r\n@media (max-width: 319px) {\r\n  .fa-solid.fa-envelope p {\r\n    display: none;\r\n  }\r\n}\r\n@media screen and (max-width: 850px) {\r\n  .footer {\r\n    padding: 4rem 2rem;\r\n  }\r\n  .footer i {\r\n    margin: 1rem 1rem 0 0;\r\n  }\r\n\r\n  .bottom div {\r\n    width: 50%;\r\n  }\r\n}\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
